import { D as Dexie } from "./import-wrapper-prod-d0T2Ruzo.js";
const db = new Dexie("Donations");
db.on("versionchange", () => {
  db.delete().then(() => console.log("Deleted database")).catch(console.error);
});
async function upgrade(trans) {
  const db2 = trans;
  await Promise.allSettled([
    db2.donations.clear(),
    db2.metaData.clear(),
    db2.fundraisingEventDonationFeed.clear(),
    db2.fundraisingEventDonationFeedMetaData.clear()
  ]);
  console.log("Cleared tables on upgrade");
}
db.version(210).stores({
  donations: `
        &id,
        __typename,
        fundraisingEventId,
        markedAsRead,
        markedAsSeen,
        amountInCents,
        confirmedAt,
        syncedAt,
        displayName,
        message,
        showAmount`,
  fundraisingEventDonationFeed: `
        &id,
        __typename,
        fundraisingEventId,
        markedAsSeen,
        amountInCents,
        createdAt,
        syncedAt,
        displayName,
        message,
        showAmount`,
  metaData: `
        &fundraisingEventId,
        cursor,
        lastSeenAt,
        donationAmountSum`,
  fundraisingEventDonationFeedMetaData: `
        &fundraisingEventId,
        cursor,
        lastSeenAt,
        receivedAmountInCents,
        lastSeenDonationId,
        receivedDonationsCount`,
  selectedFilters: `
        &fundraisingEventId,
        sortBy,
        showMessages,
        showAmountDonationsOnly`
}).upgrade(upgrade);
db.version(213).stores({
  donations: `
        &id,
        __typename,
        fundraisingEventId,
        markedAsRead,
        markedAsSeen,
        amountInCents,
        confirmedAt,
        syncedAt,
        displayName,
        message,
        showAmount`,
  fundraisingEventDonationFeed: `
        &id,
        __typename,
        fundraisingEventId,
        markedAsSeen,
        amountInCents,
        createdAt,
        confirmedAt,
        syncedAt,
        displayName,
        message,
        showAmount`,
  metaData: `
        &fundraisingEventId,
        cursor,
        lastSeenAt,
        donationAmountSum`,
  fundraisingEventDonationFeedMetaData: `
        &fundraisingEventId,
        cursor,
        lastSeenAt,
        receivedAmountInCents,
        lastSeenDonationId,
        receivedDonationsCount`,
  selectedFilters: `
        &fundraisingEventId,
        sortBy,
        showMessages,
        showAmountDonationsOnly`
}).upgrade(upgrade);
db.version(214).stores({
  donations: `
        &id,
        __typename,
        fundraisingEventId,
        markedAsRead,
        markedAsSeen,
        amountInCents,
        confirmedAt,
        syncedAt,
        displayName,
        message,
        showAmount,
        [fundraisingEventId+confirmedAt]`,
  fundraisingEventDonationFeed: `
        &id,
        __typename,
        fundraisingEventId,
        markedAsSeen,
        amountInCents,
        createdAt,
        confirmedAt,
        syncedAt,
        displayName,
        message,
        showAmount,
        [fundraisingEventId+confirmedAt]`,
  metaData: `
        &fundraisingEventId,
        cursor,
        lastSeenAt,
        donationAmountSum`,
  fundraisingEventDonationFeedMetaData: `
        &fundraisingEventId,
        cursor,
        lastSeenAt,
        receivedAmountInCents,
        lastSeenDonationId,
        receivedDonationsCount`,
  selectedFilters: `
        &fundraisingEventId,
        sortBy,
        showMessages,
        showAmountDonationsOnly`
}).upgrade(upgrade);
export {
  db as default
};
